import { Autocomplete, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { CSSProperties, useCallback, useMemo, useState } from 'react';
import RESOURCES from '~/resources';
import { ARIA_LABELS_RESOURCES } from '~/resources/resources';
import { CityOption } from './citiesAutocompleteData';
import { autoCompleteStyle, autocompleteLabelStyles } from './useStyles';

interface CitiesAutocompleteProps {
  cities: string[] | undefined;
  loading: boolean;
  // eslint-disable-next-line no-unused-vars
  handleCityChange: (event: any, city: CityOption) => void;
  topLabel?: string;
  placeholder: string;
  city: string | undefined;
  customStyle?: CSSProperties;
}

const CitiesAutocomplete = ({
  cities,
  loading,
  handleCityChange,
  topLabel,
  placeholder,
  city,
  customStyle,
}: CitiesAutocompleteProps) => {
  const [isTouched, setIsTouched] = useState(false);

  const handleOnBlur = useCallback(() => {
    setIsTouched(true);
  }, []);

  const handleOnFocus = useCallback(() => {
    setIsTouched(false);
  }, []);

  const citiesOptions = useMemo(() => {
    return (
      cities?.map((item) => {
        return { label: item, value: item };
      }) || []
    );
  }, [cities]);

  const selectedCity = useMemo(
    () => citiesOptions.find((c) => c.value === city),
    [city, citiesOptions],
  );

  return (
    <Autocomplete
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      disabled={loading}
      disablePortal={false}
      disableClearable
      options={citiesOptions}
      value={selectedCity}
      sx={{ ...autoCompleteStyle, ...customStyle }}
      size="small"
      aria-label={`${ARIA_LABELS_RESOURCES.CHOSEN} ${selectedCity?.value}`}
      onChange={handleCityChange}
      noOptionsText={RESOURCES.CREATE_MEETING_NO_CITIES_FOUND}
      popupIcon={<ExpandMoreIcon />}
      renderInput={(params) => (
        <>
          {topLabel && (
            <Typography sx={autocompleteLabelStyles}>{topLabel}</Typography>
          )}
          <TextField
            placeholder={placeholder}
            error={!selectedCity && isTouched}
            helperText={
              !selectedCity && isTouched
                ? RESOURCES.VALIDATION_HELPER_TEXT_REQUIRED_FIELD
                : ''
            }
            {...params}
          />
        </>
      )}
    />
  );
};

export default CitiesAutocomplete;
